function addCustomEventListener(selector, event, handler) {
    var rootElement = document.querySelector('body');
    //since the root element is set to be body for our current dealings
    rootElement.addEventListener(event, function (evt) {
        var targetElement = evt.target;
        while (targetElement != null) {
            if (targetElement.matches(selector)) {
                handler(evt, targetElement);
                return;
            }
            targetElement = targetElement.parentElement;
        }
    });
}
//adding the Event Listeners to all the li tasks
addCustomEventListener('a[data-method]', 'click', function (evt, target) {
    evt.preventDefault();
    var url = target.getAttribute('href');
    var message = target.dataset.message || 'Etes-vous sûr de vouloir continuer ?';
    var method = target.dataset.method;
    var csrfInput = document.createElement('input');
    var methodInput = document.createElement('input');
    var form = document.createElement('form');
    csrfInput.type = 'hidden';
    csrfInput.name = '_token';
    csrfInput.value = document.querySelector('meta[name="csrf-token"]')
        .getAttribute('content');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'DELETE';
    form.method = 'POST';
    form.action = url;
    form.appendChild(csrfInput);
    form.appendChild(methodInput);
    if (confirm(message)) {
        document.body.appendChild(form);
        form.submit();
    }
    console.log('elements', url, message, method);
});
